import { Week_State } from '@app/filter/week-filter'
import { DateTime } from 'luxon'

export class Date_Filter {
    current_week?: Week_State
    current_month?: any
    current_year?: any
    container: HTMLElement|null = null

    constructor() {
        this.set_container()
        this.set_current_week()
    }

    protected set_container() {
        const element: HTMLElement|null = document.querySelector( '.list-date-container' )

        if ( ! element ) {
            throw new Error( 'no container found' );
        }

        this.container = element
    }

    protected get_container() {
        if ( ! this.container ) {
            throw new Error( 'no container found' );
        }
        return this.container;
    }

    get_current_start(): DateTime {
        if ( this.current_week ) {
            return this.current_week.start_of_week
        }

        if ( this.current_month ) {
            return this.current_month.start_of_month
        }

        if ( this.current_year ) {
            return this.current_year.start_of_year
        }

        throw new Error( 'no current start' )
    }

    get_current_end(): DateTime {
        if ( this.current_week ) {
            return this.current_week.end_of_week
        }

        if ( this.current_month ) {
            return this.current_month.end_of_month
        }

        if ( this.current_year ) {
            return this.current_year.end_of_year
        }

        throw new Error( 'no current end' )
    }

    change_current_week( offset: number ) {
        if ( ! this.current_week ) {
            return
        }

        const monday = DateTime.fromObject(
            {
                weekNumber: this.current_week.week,
                weekYear: this.current_week.year,
            }
        )

        const updated_monday = offset === 1 ? monday.plus( { weeks: 1 } ) : monday.minus( { weeks: 1 } )

        this.update_current_week( updated_monday )
    }

    set_current_week( date?: DateTime ): void {
        const now = date ? date : DateTime.local()

        this.current_week = {
            week: now.weekNumber,
            year: now.weekYear,
            formatted_week: `${now.toFormat( 'WW/kkkk' )}`,
            start: now.startOf( 'week' ).toISODate(),
            start_of_week: now.startOf( 'week' ),
            end: now.endOf( 'week' ).toISODate(),
            end_of_week: now.endOf( 'week' ),
            days: {
                mon: now.startOf( 'week' ),
                tue: now.startOf( 'week' ).plus( { days: 1 } ),
                wed: now.startOf( 'week' ).plus( { days: 2 } ),
                thu: now.startOf( 'week' ).plus( { days: 3 } ),
                fri: now.startOf( 'week' ).plus( { days: 4 } ),
            }
        }

        this.current_month = undefined
        this.current_year = undefined

        console.log( 'current week', this.current_week )
    }

    update_current_week( updated_monday: DateTime ) {
        console.log( 'updated week', updated_monday.toFormat( 'WW/kkkk' ) )

        this.set_current_week( updated_monday )

        this.render_date()
    }

    change_current_month( offset: number ) {
        if ( ! this.current_month ) {
            return
        }

        const date = this.current_month.start_of_month

        const updated = offset === 1 ? date.plus( { months: 1 } ) : date.minus( { months: 1 } )

        this.update_current_month( updated )
    }

    set_current_month( date?: DateTime ): void {
        const now = date ? date : DateTime.local()

        this.current_month = {
            month: now.month,
            formatted_month: now.setLocale( 'de' ).toFormat( 'LLLL' ),
            year: now.year,
            start: now.startOf( 'month' ).toISODate(),
            start_of_month: now.startOf( 'month' ),
            end: now.endOf( 'month' ).toISODate(),
            end_of_month: now.endOf( 'month' ),
        }

        this.current_week = undefined
        this.current_year = undefined

        console.log( 'current month', this.current_month )
    }

    update_current_month( updated_day: DateTime ) {
        console.log( 'updated month', updated_day.month )

        this.set_current_month( updated_day )

        this.render_date()
    }

    change_current_year( offset: number ) {
        if ( ! this.current_year ) {
            return
        }

        const date = this.current_year.start_of_year

        const updated = offset === 1 ? date.plus( { years: 1 } ) : date.minus( { years: 1 } )

        this.update_current_year( updated )
    }

    set_current_year( date?: DateTime ): void {
        const now = date ? date : DateTime.local()

        this.current_year = {
            year: now.year,
            start: now.startOf( 'year' ).toISODate(),
            start_of_year: now.startOf( 'year' ),
            end: now.endOf( 'year' ).toISODate(),
            end_of_year: now.endOf( 'year' ),
        }

        this.current_week = undefined
        this.current_month = undefined

        console.log( 'current year', this.current_year )
    }

    update_current_year( updated_day: DateTime ) {
        console.log( 'updated year', updated_day.year )

        this.set_current_year( updated_day )

        this.render_date()
    }

    render_date() {
        const container = this.get_container()

        if ( this.current_week ) {
            const date_element = container.querySelector( '.data' ) as HTMLElement
            date_element.innerHTML = `${this.current_week.formatted_week}`

            const start_end = container.querySelector( '.start-end' ) as HTMLElement
            start_end.innerHTML = `${this.current_week.start_of_week.toFormat( 'D' )} - ${this.current_week.end_of_week.toFormat( 'D' )}`

            return
        }

        if ( this.current_month ) {
            const date_element = container.querySelector( '.data' ) as HTMLElement
            date_element.innerHTML = `${this.current_month.formatted_month} ${this.current_month.year}`

            const start_end = container.querySelector( '.start-end' ) as HTMLElement
            start_end.innerHTML = `${DateTime.fromISO( this.current_month.start ).toFormat( 'D' )} - ${DateTime.fromISO( this.current_month.end ).toFormat( 'D' )}`

            return
        }

        if ( this.current_year ) {
            const date_element = container.querySelector( '.data' ) as HTMLElement
            date_element.innerHTML = `${this.current_year.year}`

            const start_end = container.querySelector( '.start-end' ) as HTMLElement
            start_end.innerHTML = `${DateTime.fromISO( this.current_year.start ).toFormat( 'D' )} - ${DateTime.fromISO( this.current_year.end ).toFormat( 'D' )}`

            return
        }
    }

    disable_filter_interactions() {
        const buttons = Array.from( this.get_container().querySelectorAll( 'button' ) )
        for ( const button of buttons ) {
            button.classList.add( 'disabled' )
        }

        this.get_container().classList.add( 'loading' )
    }

    enable_filter_interactions() {
        const buttons = Array.from( this.get_container().querySelectorAll( 'button' ) )
        for ( const button of buttons ) {
            button.classList.remove( 'disabled' )
        }

        this.get_container().classList.remove( 'loading' )
    }
}
